import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsExpertsexchangeComponent } from './simple-icons-expertsexchange.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsExpertsexchangeComponent ],
    exports:      [ SimpleIconsExpertsexchangeComponent ],
    bootstrap:    []
})
export class SimpleIconsExpertsexchangeModule {}
